"use client";

import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { ENV } from "@/constants";
import { EnvironmentEnum } from "@/enums";
import { CodeBlock } from "@/ui/code-block";
import { toast } from "@/ui/toast";

type ToastErrorDetailsProps = {
  id: string;
  children?: ReactNode;
  className?: string;
  copyValue?: string;
};

export function ToastErrorDetails({
  id,
  children,
  className,
  copyValue,
}: ToastErrorDetailsProps) {
  const t = useTranslations("errors.toast");
  const isDev = ENV === EnvironmentEnum.DEVELOPMENT;

  return (
    <div className={twMerge("mt-2 space-y-2", className)}>
      <div className="text-xs font-medium text-ui-fg">
        {t(`details.${isDev ? "development" : "default"}`)}
      </div>
      {isDev && children && (
        <>
          <CodeBlock
            className="max-h-12 sm:max-h-16"
            copy={Boolean(copyValue)}
            copyValue={copyValue}
            copySubject={t("details.subject")}
          >
            {children}
          </CodeBlock>
          <XMarkIcon
            className="!absolute -right-4 -top-4 size-4.5 m-2 shrink-0 cursor-pointer rounded text-ui-icon-muted hover:bg-ui-icon-muted/10 hover:text-ui-icon-hover"
            title={t("closeError")}
            aria-label={t("closeError")}
            onClick={(e) => {
              e.stopPropagation();
              toast.dismiss(id);
            }}
          />
        </>
      )}
    </div>
  );
}
